export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CD-7e8991795c58df0da4e915ed966649ec.png";